import useAjax from "@hooks/use-ajax.hook";
import useDataStore from "@state/DataStore";
import dayjs from "dayjs";
import { useCallback } from "react";
import { SettingType } from "src/types/types";

const useSettings = (selectedMonth: number, selectedYear: number) => {
  const settings = useDataStore((state) => state.settings);
  const { request, error, loading, clearError } = useAjax();

  const fetchSettings = useCallback(async () => {
    const data = await request<SettingType[]>("get_settings", {
      selectedMonth: selectedMonth.toString(),
      selectedYear: selectedYear.toString(),
    });
    useDataStore.getState().setSettings(
      data?.map(({ date, ...d }) => ({
        ...d,
        date: dayjs(date).toDate(),
      })) ?? []
    );
  }, [request, selectedMonth, selectedYear]);

  return { settings, loading, error, clearError, fetchSettings };
};

export default useSettings;
